import React from "react";
import { Users, UserPlus, Eye, Briefcase, Building, UserCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  // These would normally use router navigation, but for demonstration
  // we'll just use mock functions

  const handleAddClient = () => navigate("/add-client");
  const handleViewClients = () => navigate("/clients");

  const handleAddEmployee = () => navigate("/add-employee");
  const handleViewEmployees = () => navigate("/employees");

  const handleAddBroker = () => navigate("/add-broker");
  const handleViewBrokers = () => navigate("/brokers");

  // Dashboard card data for reusable components
  const dashboardCards = [
    {
      title: "Clients",
      icon: <Users size={24} className="text-blue-600" />,
      description: "Manage your client database",
      actions: [
        { 
          label: "Add Client", 
          icon: <UserPlus size={18} />, 
          onClick: handleAddClient,
          color: "bg-blue-50 text-blue-700 hover:bg-blue-100 border-blue-200" 
        },
        { 
          label: "View Clients", 
          icon: <Eye size={18} />, 
          onClick: handleViewClients,
          color: "bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200" 
        }
      ],
      color: "bg-blue-50",
      borderColor: "border-blue-200"
    },
    {
      title: "Employees",
      icon: <Briefcase size={24} className="text-purple-600" />,
      description: "Manage your staff members",
      actions: [
        { 
          label: "Add Employee", 
          icon: <UserPlus size={18} />, 
          onClick: handleAddEmployee,
          color: "bg-purple-50 text-purple-700 hover:bg-purple-100 border-purple-200" 
        },
        { 
          label: "View Employees", 
          icon: <Eye size={18} />, 
          onClick: handleViewEmployees,
          color: "bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200" 
        }
      ],
      color: "bg-purple-50",
      borderColor: "border-purple-200"
    },
    {
      title: "Brokers",
      icon: <Building size={24} className="text-green-600" />,
      description: "Manage your broker relationships",
      actions: [
        { 
          label: "Add Broker", 
          icon: <UserCheck size={18} />, 
          onClick: handleAddBroker,
          color: "bg-green-50 text-green-700 hover:bg-green-100 border-green-200" 
        },
        { 
          label: "View Brokers", 
          icon: <Eye size={18} />, 
          onClick: handleViewBrokers,
          color: "bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200" 
        }
      ],
      color: "bg-green-50",
      borderColor: "border-green-200"
    }
  ];

  return (
    <div className="bg-gray-100 min-h-screen p-3 md:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
          <div className="border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white p-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Dashboard
            </h2>
            <p className="text-gray-500 mt-1">Manage your business from one central location</p>
          </div>

          <div className="p-3 md:p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {dashboardCards.map((card, index) => (
                <div 
                  key={index} 
                  className={`rounded-lg border ${card.borderColor} overflow-hidden transition duration-200 hover:shadow-md`}
                >
                  <div className={`${card.color} p-5 flex items-center space-x-3`}>
                    {card.icon}
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800">{card.title}</h3>
                      <p className="text-sm text-gray-600">{card.description}</p>
                    </div>
                  </div>
                  
                  <div className="bg-white p-4 space-y-3">
                    {card.actions.map((action, actionIndex) => (
                      <button
                        key={actionIndex}
                        onClick={action.onClick}
                        className={`${action.color} flex items-center space-x-2 py-3 px-4 rounded-md border w-full font-medium text-sm transition-all duration-200`}
                      >
                        {action.icon}
                        <span>{action.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;